export default __webpack_public_path__ + "static/media/me.min.99b9d444.png";